export default "__VITE_ASSET__DjCWYGRV__"